define('views/modules/template/edit/template-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    // services
    'services/layout',
    'services/events/calendar-events',
    'services/events/template-events',
    'services/toastr-service',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/modules/template/edit/form/template-form',
    'views/modules/template/edit/calendar/calendar-component/template-calendar',
    'views/modules/template/assignment/manager/per-template/assignment-manager-panel',
    // modals
    'views/modules/template/edit/modal/exercises-not-found-modal',
    // templates
    'text!templates/modules/template/edit/template-content.html'
], function(
    // libs
    _, Backbone, Mustache, U, i18n,
    // services
    LayoutState,
    CalendarEvents,
    TemplateEvents,
    ToastrService,
    // views
    VForm,
    VMenuSaveAction,
    VTemplateForm,
    VTemplateCalendar,
    VAssignmentManagerPanel,
    // modals
    VExerciseNotFoundModal,
    // templates
    TTemplateContent
) {

    var VTemplateContent = VForm.extend({
        template: TTemplateContent,

        regions: {
            menu: '.menu-actions',
            calendar: '.calendar-component',
            form: '.template-form',
        },

        events: {
            "blur .name-input input": "onNameBlur",
            "keydown .name-input input": "onNameKeydown",
            "click .share-input :checkbox": "onShareClick"
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                role: opt.role,
                profile: opt.profile
            });

            this.lastSavedAt = null;
            var model = this.model,
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSaveTemplate: this.onSaveTemplate,
                        saveText: "Save",
                        collection: new Backbone.Collection([
                            { disabled: true, title: i18n.t("calendar:Manage template assignments"), icon: 'sl-icon-organization', btnClass: 'btn-tc-white', itemClass: 'btn-manage-assignments', content: i18n.t("calendar:Manage template assignments"), callback: this.onManageAssignments }
                        ])
                    }),
                    form: new VTemplateForm({
                        model: model,
                    }),
                    calendar: new VTemplateCalendar({
                        model: model,
                        profile: this.profile,
                        role: this.role,
                        group: opt.group
                    }),
                };

            this.listenTo(model, {
                'model:reset': this.onModelReset,
                'change:save': this.onSaveTemplate,
                'sync': this.onModelSync
            });

            this.listenTo(CalendarEvents, 'removeNonEmptyWeek', this.onSaveTemplate);

            this.initLastSavedAtInterval();
        },

        // Refresh the "saved X minutes ago" span every 60 seconds
        initLastSavedAtInterval: function() {
            if (this.lastSavedAtInterval) window.clearInterval(this.lastSavedAtInterval);

            this.lastSavedAtInterval = window.setInterval(function() {
               if (this.lastSavedAt) {
                   Backbone.$('.last-saved-at').html(this.computeLastSavedAt());
               }
            }.bind(this), 60000);
        },

        render: function() {
            // Render Template HTML with Mustache
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.form, zone.$form)
                .assign(view.menu, zone.$menu)
                .assign(view.calendar, zone.$calendar)
        },

        resetCalendarItemsCopy: function() {
            this.view.calendar.resetItemsCopy();
        },

        getCalendarItems: function() {
            return this.view.calendar.getItems();
        },

        getCalendarItemsCopy: function() {
            return this.view.calendar.getItemsCopy();
        },

        isDirty: function() {
            return VTemplateContent.__super__.isDirty.apply(this, arguments) ||
                !this.getCalendarItems().equals(this.getCalendarItemsCopy()) ||
                !this.model.getSessions().equals(this.sessionsCopy);
        },

        computeLastSavedAt: function() {
            if (!this.lastSavedAt) {
                return '';
            }

            return i18n.t('saved-at', { time: this.lastSavedAt.fromNow() });
        },

        changeMenuActionsState: function() {
            var button = this.view.menu.collection.find(function(m) { return m.get('itemClass') === "btn-manage-assignments"; });

            button.set("disabled", false);
            this.view.menu.toggleSaveButton(false);
            button.set("title", i18n.t("template:Manage current template assignments"));

            if (this.isDirty() || this.model.isNew()) {
                button.set("disabled", true);
                this.view.menu.toggleSaveButton(true);
                button.set("title", i18n.t("template:Please save your template before assigning it to clients"));
            }

            this.view.menu.render();
        },

        templateNameHasChanged: function() {
            return this.templateName !== this.model.get('name')
        },

        ////////////
        // events //
        ////////////

        onResize: function(e) {
            var view = this.view.calendar;
            if (view.onResize) view.onResize(e);
        },

        onSaveTemplate: function() {
            if (this.model.getSessions().getInvalidSessions().length > 0) {
                (new VExerciseNotFoundModal({ errors: this.model.getSessions().getInvalidSessions() })).render();
                return;
            }

            this.view.form.setDisabled(true);
            this.changeMenuActionsState();

            var items = this.view.calendar.items,
                model = this.model;

            if (_.isEmpty(this.model.get('name'))) {
                this.model.set('name', 'Untitled');
            }

            Backbone.$('.last-saved-at').html(i18n.t('saving-in-progress'));

            if (this.model.getSessions().getInvalidSessions().length > 0) {
                (new VExerciseNotFoundModal({ errors: this.model.getSessions().getInvalidSessions() })).render();
                return;
            }

            model.unparseDays(items)
                .unparseSessions();

            this.lastSavedAt = moment();
            this.save(model.attributes, {
                patch: false
            })
        },

        onModelReset: function(model) {
            if (this.view.form.$el.html() !== "") {
                this.view.form.setDisabled(false);
            }
            this.templateName = model.get('name');
            this.sessionsCopy = model.getSessions().toJSON();
            this.resetCalendarItemsCopy();
            this.changeMenuActionsState();
            Backbone.$('.last-saved-at').html('');
        },

        onModelSync: function() {
            if (this.lastSavedAt) {
                Backbone.$('.last-saved-at').html(this.computeLastSavedAt());
                this.view.form.setDisabled(false);
            }
            this.changeMenuActionsState();
        },

        onManageAssignments: function() {
            this.when(this.collection.getFirstPage()).then(function() {
                if (this.model.getSessions().getInvalidSessions().length > 0) {
                    (new VExerciseNotFoundModal({ errors: this.model.getSessions().getInvalidSessions() })).render();
                    return;
                }

                var view = this.view,
                    collection = this.collection,
                    model = this.model,
                    manager = view.manager || (view.manager = new VAssignmentManagerPanel({
                        model: model,
                        collection: collection,
                        group: this.options.group
                    }));

                LayoutState.setInfo(manager, { open: true });
            });
        },

        onNameKeydown: function(e) {
            if (e.keyCode === 13 && this.templateNameHasChanged()) {
                this.model.trigger('change:save');
                this.templateName = this.model.get('name');
            }
        },

        onNameBlur: function(e) {
            if (this.templateNameHasChanged() && !e.target.disabled) {
                this.model.trigger('change:save');
                this.templateName = this.model.get('name');
            }
        },

        onShareClick: function(e) {
            // Set the value manually because the value doesn't seems to change now that we have a event listener for this field
            this.model.set('sharedToSubgroups', e.target.checked);
            this.view.form.setDisabled(true);
            this.model.trigger('change:save');
        }
    });

    return VTemplateContent;

});

